import { useNavigate } from 'react-router-dom';

// Sinut lisättiin projektiin "otsikko"  EVENT_TYPE_PROJECT_PARTICIPANT_ADDED
// Sinut merkattiin projektin "otsikko" tehtävään  EVENT_TYPE_PROJECT_TASK_ASSIGNED
// Sinulle merkatussa projektin "otsikko" tehtävässä muutoksia  EVENT_TYPE_PROJECT_TASK_CHANGED
// Sinulle merkattuun projektin "otsikko" tehtävään tuli kommentti  EVENT_TYPE_PROJECT_TASK_COMMENT_ADDED

import { basePath as projectsPath } from '../../../projects/ducks';

import StandardNotification from './StandardNotification';

const getText = notification => {
  const { projectTitle: title } = notification.details;
  switch (notification.action) {
    case 'EVENT_TYPE_PROJECT_INFO':
      return `Projektiin ${title} tehtiin muutos`;
    case 'EVENT_TYPE_PROJECT_PARTICIPANT_ADDED':
      return `Sinut lisättiin projektiin ${title}`;
    case 'EVENT_TYPE_PROJECT_TASK_ASSIGNED':
      return `Sinut merkattiin projektin ${title} tehtävään`;
    case 'EVENT_TYPE_PROJECT_TASK_CHANGED':
      return `Sinulle merkatussa projektin ${title} tehtävässä muutoksia`;
    case 'EVENT_TYPE_PROJECT_TASK_COMMENT_ADDED':
      return `Sinulle merkattuun projektin ${title} tehtävään tuli kommentti`;
    default:
      return 'Tuntematon viestityyppi';
  }
};

const ProjectNotification = ({ notification, ...rest }) => {
  const navigate = useNavigate();

  const handleClick = async () => {
    navigate(`${projectsPath}/${notification.details.projectId}`);
  };

  return (
    <StandardNotification
      {...rest}
      notification={notification}
      description={getText(notification)}
      onClick={handleClick}
    />
  );
};

export default ProjectNotification;
